<script>
  export let isToggled = false;
  $: container = undefined;
  $: height = 0;
  $: if (container !== undefined && height === 0) {
    height = container.firstChild.getBoundingClientRect().height;
  }
</script>

<div class="dropdown" bind:this={container}>
  <button on:click={() => (isToggled = !isToggled)}>👁</button>
  {#if isToggled}
    <div class="dropdown-content" style={`top: ${height}px`}>
      <slot />
    </div>
  {/if}
</div>

<style>
  .dropdown {
    position: relative;
  }
  .dropdown-content {
    top: 20px;
    position: absolute;
    background-color: white;
    display: flex;
    flex-direction: column;
    width: max-content;
    padding: 8px;
  }
</style>
